<template>
  <card>
    <language-list
      v-if="$store.state.user.is_root"
      v-model="params['locale']"
      :isAll="true"
      @input="params['page'] = 1"
    />
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :params="params"
      :setLink="setLink"
      :filters="filters"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      params: {},
      modalCreate: "work",

      filters: [
        {
          key: "course",
          title: "Номер Класса",
        },
        {
          key: "business_discipline",
          title: "Дисциплина",
        },
      ],

      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_work_view",
      itemLink: "business/works",
      setLink: "business/works",
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "lessonplan",
          title: "Плановый урок",
          object: "title",
          disableLink: true,
        },
        {
          key: "title",
          title: "Предмет",
          object: "lessonplan",
          subobject: "discipline",
          disableLink: true,
        },
        {
          key: "lessonplan",
          title: "Язык",
          object: "locale",
          disableLink: true,
        },
        {
          key: "title",
          object: "lessonplan",
          title: "Класс",
          subobject: "course",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
